import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useCart } from '@/hooks/useCartContext';
import FutureIcon from '@/components/base/FutureIcon';

export default function FloatingCart() {
  const { t } = useTranslation();
  const { totalItems } = useCart();
  const [bumped, setBumped] = useState(false);
  const prevItemsRef = useRef(totalItems);

  // Bump the orb whenever something new lands in the cart
  useEffect(() => {
    const grew = totalItems > prevItemsRef.current;
    prevItemsRef.current = totalItems;
    if (!grew) return;
    setBumped(true);
    const timer = setTimeout(() => setBumped(false), 650);
    return () => clearTimeout(timer);
  }, [totalItems]);

  if (totalItems === 0) return null;

  return (
    <Link to="/carrinho" className={`cart-orb ${bumped ? 'is-bumped' : ''}`} aria-label={t('homeUi.cart.floatingAria')}>
      <FutureIcon name="bag" />
      <span key={totalItems} className="cart-count">{totalItems}</span>
    </Link>
  );
}
